module.exports = __webpack_public_path__ + "static/media/importFlybook1.1830b7e4.png";